module.exports = __webpack_public_path__ + "img/7822.2f3388e5.svg";